export default __webpack_public_path__ + "static/banner-texture-1e945c045fc7c420cacb3042209eb2d5.png";